import { render, staticRenderFns } from "./TitleBoxOld.vue?vue&type=template&id=03767f7a&scoped=true"
import script from "./TitleBoxOld.vue?vue&type=script&lang=js"
export * from "./TitleBoxOld.vue?vue&type=script&lang=js"
import style0 from "./TitleBoxOld.vue?vue&type=style&index=0&id=03767f7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03767f7a",
  null
  
)

export default component.exports